import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";
import React from "react";

export const LoadingIndicatorWithSpin = ({
  fontSize,
}: {
  fontSize?: string;
}) => {
  return <Loader2 className={cn("mr-2 h-4 w-4 animate-spin", fontSize)} />;
};

export const LoadingIndicatorWithoutSpin = () => {
  return <Loader2 className="mr-2 h-4 w-4 animate-spin" />;
};

export const SuspenseLoadingIndicator = ({
  style,
}: {
  style?: React.CSSProperties;
}) => (
  <div
    style={style}
    className="flex flex-col justify-center items-center w-full h-full"
  >
    <LoadingIndicatorWithSpin />
  </div>
);

export const ListLoadingIndicator = ({
  heightClassName = "h-3",
  itemCount = 5,
  containerClassName,
}: {
  heightClassName?: string;
  itemCount?: number;
  containerClassName?: string;
}) => {
  return (
    <div
      className={cn(
        "animate-pulse flex flex-col w-full h-full",
        containerClassName
      )}
    >
      {new Array(itemCount).fill(null).map((item, index) => (
        <div
          key={index.toString()}
          className={cn(
            "bg-slate-200 dark:bg-slate-700 rounded-lg",
            heightClassName,
            {
              "opacity-50": index > itemCount / 2 && index < itemCount - 1,
              "opacity-20": index === itemCount - 1,
            }
          )}
        ></div>
      ))}
    </div>
  );
};
